import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';

import { updateAccount,
         invokeLogger,
         sendActivationMail } from './actions/account';

import fetchStates from './reducers/fetchStates';

class Profilim extends Component {
    state = {
        ad: this.props.account.ad,
        soyad: this.props.account.soyad,
        mobiltelefon: this.props.account.mobiltelefon,
        haberler: this.props.account.haberler,
        password: '',
        passwordChange: false,
        error: ''
    }

    componentDidMount() {
        const id = this.props.account.id;
        const text = "Profilim: " + this.props.account.email;
        this.props.invokeLogger({ id, text });
        window.scrollTo(0, 0);
    }

    togglePasswordChange = (event) => {
        this.setState({ passwordChange: !this.state.passwordChange });
    }

    toggleNewsletter = (event) => {
        this.setState({ haberler: !this.state.haberler });
    }

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    }

    checkValidity() {
        let {
            ad,
            soyad,
            mobiltelefon,
            password
        } = this.state;

        let error = '';

        if (this.state.passwordChange && password === '') {
            error = 'Lütfen yeni şifrenizi belirtiniz';
        }
        if (mobiltelefon === '') {
            error = 'Lütfen mobil telfon numaranızı güncelleyiniz';
        }
        if (soyad === '') {
            error = 'Lütfen soyadınızı güncelleyiniz';
        }
        if (ad === '') {
            error = 'Lütfen adınızı güncelleyiniz';
        }

        this.setState({ error });
        return error === '';
    }

    Error() {
        return (
            <div>
            {
                this.state.error !== '' ?
                <div className="Warning">{this.state.error}</div>
                : null
            }
            </div>
        )
    }

    sendActivationMail = () => {
        let {
            id,
            email
        } = this.props.account;

        this.props.sendActivationMail({
            id,
            email
        });
    }

    updateMyAccount = () => {
        let {
            ad,
            soyad,
            mobiltelefon,
            haberler,
            password
        } = this.state;

        let {
            id,
            sozlesme,
            accountStatus
        } = this.props.account;

        if (!this.state.passwordChange) {
            password = '';
        }

        if (this.checkValidity()) {
            this.props.updateAccount({
                id,
                ad,
                soyad,
                mobiltelefon,
                haberler,
                sozlesme,
                accountStatus,
                password
            });
        }
    }

    render() {
        let { startDate } = this.props.account;

        let kayitTarihi = 'Hesabınız ' + startDate.substring(6, 8) + '/' 
                        + startDate.substring(4, 6) + '/' + 
                        startDate.substring(0,4) + 
                        ' tarihinden beri aktiftir';

        return (
            <div>
                {
                this.props.account.status === fetchStates.fetching ?
                <div className="Warning">Bilgilerinizi güncelliyorum
                </div> : this.Error()
                }
                <div>
                    <div className="PageText">
                        <div className="PageInputSmall">
                            {kayitTarihi}
                        </div>
                        <InputGroup>
                            <InputGroup.Prepend>
                            <InputGroup.Text style={{ width : '170px' }}>Ad</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                aria-label="ad"
                                value={this.state.ad}
                                onChange={this.handleChange}
                                placeholder='Lütfen adınızı giriniz'
                                name='ad'
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Prepend>
                            <InputGroup.Text style={{ width : '170px' }}>Soyad</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                value={this.state.soyad}
                                onChange={this.handleChange}
                                placeholder='Lütfen soyadınızı giriniz'
                                name='soyad'
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Prepend>
                            <InputGroup.Text style={{ width : '170px' }}>Mobil Telefon</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                value={this.state.mobiltelefon}
                                onChange={this.handleChange}
                                placeholder='Lütfen mobil telefon numaranızı giriniz'
                                name='mobiltelefon'
                            />
                        </InputGroup>
                        <div className="custom-control custom-checkbox PageText">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="haberler"
                                onChange={this.toggleNewsletter}
                                checked={this.state.haberler}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="haberler">
                                Bizden haber almak için işaretleyiniz
                            </label>
                        </div>
                        <div className="custom-control custom-checkbox PageText">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="passwordChange"
                                onChange={this.togglePasswordChange}
                                checked={this.state.passwordChange}
                            />
                            <label
                                className="custom-control-label"
                                htmlFor="passwordChange">
                                Şifrenizi değiştirmek için işaretleyiniz
                            </label>
                        </div>
                        {
                        this.state.passwordChange ?
                        <div>
                        <InputGroup>
                            <InputGroup.Prepend>
                            <InputGroup.Text style={{ width : '170px' }}>Yeni Şifre</InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                aria-label="password"
                                value={this.state.password}
                                onChange={this.handleChange}
                                placeholder='Lütfen yeni şifrenizi giriniz'
                                name='password'
                            />
                        </InputGroup>
                        <br />
                        </div>
                        : null
                        }
                        {
                            this.props.account.accountStatus === 'I0' ?
                            <div className='PageTextCenter'>
                                <Button variant="info" onClick={this.sendActivationMail}>Yeniden e-posta doğrulama mesajı gönder</Button>
                            </div> : null
                        }
                        <div className='PageTextCenter'>
                            <Button variant="info" onClick={this.updateMyAccount}>Profil bilgilerimi kaydet</Button>
                        </div>                        
                    </div>

                </div>
                {
                this.props.account.status === fetchStates.fetching ?
                <div className="Warning">Bilgilerinizi güncelliyorum</div>
                : this.Error()
                }
            </div>
        )
    }
}

export default connect(
    ({ account }) => ({ account }),
    { updateAccount, invokeLogger, sendActivationMail }
)(Profilim);